<script setup lang="ts">
import type { ComponentArchCarouselProps } from "./ComponentArchCarousel.props"

const props = defineProps<ComponentArchCarouselProps>()
</script>

<template>
  <div class="cms-component-arch-carousel">
    <CarouselArch v-bind="props" />
  </div>
</template>
